// extracted by mini-css-extract-plugin
export default {"langSelect":"LangSelect_langSelect__EmZR3"};